
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templiservice/[url]",
      function () {
        return require("private-next-pages/templiservice/[url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templiservice/[url]"])
      });
    }
  